const flagStyle = {
  height: '25px',
  borderRadius: '2px',
};

const selectedStyle = {
  background: '#f5f5f5',
};

export default {
  flagStyle,
  selectedStyle,
};



// WEBPACK FOOTER //
// ./src/scenes/components/Header/components/LanguageSelect/style.js